import React from 'react';
import './HomePage.css';
import AdsGrid from '../components/AdsGrid';
import RecentlyViewedList from '../components/RecentlyViewedList';
import Seo from '../components/Seo';

const HomePage = () => (
    <>
        <Seo
            title="Недвижимость — купить, снять, посуточно"
            description="Актуальные объявления о продаже и аренде квартир, домов, комнат и коммерческой недвижимости от собственников и агентств."
        />
        <div className="home-page">
            <div className="home-hero">
                <img src="/images/banner.jpg" alt="banner" className="home-hero__img" />
            </div>
        </div>
        <RecentlyViewedList />
        <AdsGrid title="Свежие объявления" />
    </>
);

export default HomePage;
